import { render, staticRenderFns } from "./AdPopup.vue?vue&type=template&id=c2f10d14&scoped=true"
import script from "./AdPopup.vue?vue&type=script&lang=js"
export * from "./AdPopup.vue?vue&type=script&lang=js"
import style0 from "./AdPopup.vue?vue&type=style&index=0&id=c2f10d14&prod&lang=scss"
import style1 from "./AdPopup.vue?vue&type=style&index=1&id=c2f10d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f10d14",
  null
  
)

export default component.exports